// Angular Imports
import { Injectable, computed, inject } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Router } from '@angular/router'
import { environment } from '@environment'
// Angular Material Imports
import { MatDialog } from '@angular/material/dialog'
// Shared Imports
import { ECountry } from '@shared/models'
import { AuthStore } from '@shared/store'
// Thirdparty Imports
import { Observable, catchError, map, throwError } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class AuthService {
	readonly #http = inject(HttpClient)
	readonly #authStore = inject(AuthStore)
	readonly #router = inject(Router)
	readonly #dialog = inject(MatDialog)

	gateway = computed<string>(() => {
		switch (this.#authStore.country()) {
			default:
				return environment.gateway
		}
	})

	constructor() {}

	updateAccessToken(refreshToken: string | null): Observable<string> {
		const headers = new HttpHeaders({
			// Authorization: '',
		})

		const payload = {
			refreshToken: refreshToken,
		}

		const url = `${this.gateway()}/auth/refresh-token`

		return this.#http.post(url, payload, { headers }).pipe(
			catchError((error) => {
				// console.log('logout', error)
				// Do logout
				this.#authStore.signout()
				this.#router.navigate(['/signout'])
				this.#dialog.closeAll()
				return throwError(() => error)
			}),
			map((response: any) => {
				console.error('updateAccessToken', response)

				if (response?.token && response?.refreshToken) {
					const newAccessToken: string = response.token
					const newRefreshToken: string = response.refreshToken

					this.#authStore.updateAccessAndRefreshToken({
						accessToken: newAccessToken,
						refreshToken: newRefreshToken,
					})

					return newAccessToken
				} else {
					throw new Error(
						'An unexpected error occurred when we tried to refresh the authentication tokens'
					)
				}
			})
		)
	}
}
